module.exports = require("string_decoder");


//////////////////
// WEBPACK FOOTER
// external "string_decoder"
// module id = 170
// module chunks = 0